export default __webpack_public_path__ + "static/media/mymoneysense-view-dashboard-desktop.8a7500a6.svg";